import { render, staticRenderFns } from "./FeaturedWinners.vue?vue&type=template&id=4e1b913c&scoped=true"
import script from "./FeaturedWinners.vue?vue&type=script&lang=js"
export * from "./FeaturedWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1b913c",
  null
  
)

export default component.exports